"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var moment_1 = __importDefault(require("moment"));
var shoudDisableOrderPickupDate_1 = require("../shoudDisableOrderPickupDate");
exports.getMinimalOrderDate = function () {
    var timeFormat = 'hh:mm:ss';
    var noonTime = moment_1.default('12:00:00', timeFormat);
    var isBeforeNoon = moment_1.default().isBefore(noonTime);
    var addDays = isBeforeNoon ? 1 : 2;
    var dateAfterAddition = moment_1.default().add(addDays, 'days');
    var isNewDateDisabled = shoudDisableOrderPickupDate_1.shouldDisableOrderPickupDate(dateAfterAddition);
    return isNewDateDisabled
        ? dateAfterAddition
            .add(1, 'week')
            .startOf('week')
            .toDate()
        : dateAfterAddition.toDate();
};
//# sourceMappingURL=getMinimalOrderDate.js.map